import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ProductsCarousel from '../Carousel/ProductsCarousel';

const ProductRelated = ({ related }) => {
  const { t } = useTranslation();
  return (
    <Box marginTop={{ xs: 6, md: 12 }}>
      <Typography
        variant='h2'
        sx={{
          marginBottom: { xs: 2, md: 4 },
          textAlign: 'center'
        }}
      >
        {t('product.relatedProducts')}
      </Typography>
      <ProductsCarousel products={related} />
    </Box>
  );
};

export default ProductRelated;
